import Vue from 'vue'
import store from '@/common/store'
import pageModule from './store/pageModule'
import components from "./components";

store.registerModule("pageModule", pageModule);
store.commit('pageModule/SET_PAGE_MODEL', window.page.model)


components.forEach(({ component, element }) => {

    // Is the custom element in the DOM?
    if (!document.querySelector(element)) {
        return;
    }

    let $element = document.querySelector(element);

    // Create a new Vue instance and mount it to the custom element.
    new Vue({
        store,
        render: createElement => {
            let componentProps = buildComponentContext(component, $element)
            const context = {
                props: { ...componentProps },
            };
            return createElement(component, context);
        }
    }).$mount(element);

});


//String
//Number
//Boolean
//Array
//Object
//Date
//Function
//Symbol


function buildComponentContext(component, element) {
    var context = {};
    var componentProps = component.props
    var elementProps = element.dataset;

    for (var i = 0; i < Object.keys(elementProps).length; i++) {
        createProperty(context, Object.keys(elementProps)[i] , componentProps, elementProps);
    }
   
    return context;
}

function createProperty(context, name, componentProps, dataset) {
    if (componentProps.hasOwnProperty(name) && dataset.hasOwnProperty(name)) {
        context[name] = extractPropTypeName(componentProps[name], dataset[name]);
    }
}

function extractPropTypeName(prop, datasetProp) {
    let typeName = "object";
    let type = null;

    if (typeof prop === "function") {
        typeName = prop.name;
    }
    if (typeof prop === "object" && prop.hasOwnProperty("type") && prop.type.hasOwnProperty("name")) {
        typeName = prop.type.name;
    }

    switch (typeName) {
        case "Object": type = Object(datasetProp); break;
        case "String": type = String(datasetProp); break;
        case "Number": type = Number(datasetProp); break;
        case "Boolean": type = Boolean(datasetProp); break;
        case "Array": type = Array(datasetProp); break;
        case "Date": type = Date(datasetProp); break;
        case "Symbol": type = Symbol(datasetProp); break;
        case "Function": type = Function(datasetProp); break;
    }

    return type;

}